import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ErrorTypes, IconTypes } from "../../interfaces/errors";

interface ToastState {
  show: boolean;
  type: ErrorTypes;
  title: string;
  message: string;
  icon: IconTypes;
}

const initialState: ToastState = {
  show: false,
  type: "success",
  title: "",
  message: "",
  icon: "check_circle",
};

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    showToast: (
      state,
      action: PayloadAction<{
        type: ErrorTypes;
        title: string;
        message: string;
        icon: IconTypes;
      }>
    ) => {
      state.show = true;
      state.type = action.payload.type;
      state.title = action.payload.title;
      state.message = action.payload.message;
      state.icon = action.payload.icon;
    },
    hideToast: (state) => {
      state.show = false;
      state.type = "success";
      state.title = "";
      state.message = "";
      state.icon = "check_circle";
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice.reducer;
